export const mockDaemonInfo = {
    status: "daemonInfoStatus",
    daemonConfig: {
        serviceEndpoint: "serviceEndpoint",
        serviceCredentials: [
            {
                key: "Authorization",
                value: "Long Secret Value",
                location: "header",
            },
            {
                key: "field2Key",
                value: "field2Value",
                location: "field2Location",
            },
        ],
    },
    data: {
        id: "mockDaemonId",
        orders: [
            {},
            {
                evmTransactions: [{}],
            },
        ],
    },
};
